import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { User } from '../../../../shared';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '../../../../core/loader/loader.service';
import { NotificationService } from '../../../../service/notification.service';
import { SalonChainMappingService } from '../../../../api/salon-chain-mapping.service';
import {
  SalonChainDataMappingModel,
} from '../../../../shared/models/salon-chain-mapping.model';
import {takeUntil} from 'rxjs/operators';
import {NotificationType} from '../../../../shared/enum/notification.enum';

@Component({
  selector: 'app-salon-chain-mapping-edit',
  templateUrl: 'salon-chain-mapping-edit.component.html'
})

export class SalonChainMappingEditComponent implements OnInit, OnDestroy {
  @Input() type = 'new';
  @Input() Id = undefined;
  @Input() currentUser: User;
  @Input() data: SalonChainDataMappingModel = {};

  public salonName = '';
  public salonWebsite = '';
  public salonComment = '';

  private _destroyed$ = new Subject();

  constructor(
	public activeModal: NgbActiveModal,
	private salonChainService: SalonChainMappingService,
	private loaderService: LoaderService,
	private notificationService: NotificationService,
  ) {
  }

  ngOnInit() {
	if (this.data) {
		this.salonName = this.data.Name;
		this.salonWebsite = this.data.Website;
		this.salonComment = this.data.Comment;
	}
  }

  saveSalonChainData(e) {
	const result = e.validationGroup.validate();
	if (result.isValid) {
		this.loaderService.show();
		const data = {
		UserId: this.currentUser.UserId,
		SalonChainId: this.data ? this.data.SalonChainId : 0,
		Name: this.salonName,
		Website: this.salonWebsite,
		Comment: this.salonComment
		};

		this.salonChainService.createOrModifySalonChainMasterData(data)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
			this.notificationService.show('Global Company Prefix created', NotificationType.Success);
			this.loaderService.hide();
			this.activeModal.dismiss('saved');
		}, );
	}
  }

  ngOnDestroy() {
	this.loaderService.hide();
	this._destroyed$.next(null);
	this._destroyed$.complete();
  }
}
